import { SortableMultiSelectField } from '@app/lib/form'
import { Component, Field, HasOne, StaticRender } from '@contember/interface'
import { PagePreview } from '../previews/page-preview'
import { PrimaryLocale } from '../primary-locale'

export const PagesNavigationForm = Component(() => (
	<SortableMultiSelectField field="pages" label="Navigation pages" sortableBy="displayOrder" connectAt="page">
		<PrimaryLocale>
			<PagePreview />
		</PrimaryLocale>
		<StaticRender>
			<HasOne field="hero">
				<PrimaryLocale>
					<Field field="title" />
					<Field field="description" />
				</PrimaryLocale>
			</HasOne>
		</StaticRender>
	</SortableMultiSelectField>
))
